import { render } from "./KeepAlive.vue?vue&type=template&id=10078944"
import script from "./KeepAlive.vue?vue&type=script&lang=js"
export * from "./KeepAlive.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__